import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Rating,
  TextField,
  Box
} from '@mui/material';
import { updateDoc, doc, getDoc, collection, addDoc } from '@firebase/firestore';
import { db } from '../service/Firebase-config';
import { useGlobalContext } from '../context/GlobalContext';

export default function DialogEditRating({ open, handleClose, row }) {
    const { selectedUser, setTotalStars } = useGlobalContext();
    const [newRating, setNewRating] = useState(0);
    const [comment, setComment] = useState('');

    useEffect(() => {
        !!row?.rating? setNewRating(row.rating): setNewRating(0);
    }, [row]);

    const handleSubmit = async (event) => {
        event.preventDefault();

        const homeworkRef = doc(db, `students/${selectedUser.uid}/homeworks/`, row.id);
        const studentRef = doc(db, `students`, selectedUser.uid);

        try {
            const studentSnapshot = await getDoc(studentRef);
            if (studentSnapshot.exists()) {
                const studentData = studentSnapshot.data();
                const currentTotalStars = studentData.totalStars || 0;

                const homeworkSnapshot = await getDoc(homeworkRef);
                if (homeworkSnapshot.exists()) {
                    const homeworkData = homeworkSnapshot.data();
                    const currentRating = homeworkData.rating || 0;

                    const newTotalStars = currentTotalStars + (newRating || 0) - currentRating;

                    await updateDoc(homeworkRef, { rating: newRating });
                    await updateDoc(studentRef, { totalStars: newTotalStars });

                    setTotalStars(newTotalStars);
                }
            }

            const homeworkData = {
                isNewComment: !!comment && comment.length > 0,
            };

            await updateDoc(homeworkRef, homeworkData);

            if (comment && comment !== '') {
                const commentData = {
                    createdDate: new Date(),
                    comment: comment,
                    fromWhom: 'teacher',
                };
                const commentsCollection = collection(db, `students/${selectedUser.uid}/homeworks/${row.id}/comments`);
                await addDoc(commentsCollection, commentData);
            }
        } catch (e) {
            alert(`Error! ${e.message}`);
        }

        setComment('');
        handleClose();
    };

    const handleClearRating = () => {
        setNewRating(0);
    };

    const handleCancel = () => {
        setComment('');
        handleClose();
    };

    return (
        <Dialog open={open} onClose={handleCancel} maxWidth="sm" fullWidth>
            <DialogTitle>
                Edit {new Date(row?.createdDate.seconds * 1000).toLocaleString("en-US", { month: "short", day: "2-digit", year: "numeric" })} {row?.subject} Homework Rating
            </DialogTitle>
            <DialogContent>
                <Box display="flex" alignItems="center" mb={2}>
                    <Rating
                        name="simple-controlled"
                        value={newRating}
                        onChange={(event, newValue) => setNewRating(newValue)}
                    />
                    <Button onClick={handleClearRating} style={{ marginLeft: '10px' }} variant="outlined">
                        Clear
                    </Button>
                </Box>
                <TextField
                    margin="dense"
                    id="comment"
                    name="comment"
                    label="Message"
                    multiline
                    rows={2}
                    fullWidth
                    variant="outlined"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel}>Cancel</Button>
                <Button onClick={handleSubmit} variant="contained">Save</Button>
            </DialogActions>
        </Dialog>
    );
}
